import React, { useEffect, useState } from "react";

import {
  Dialog,
  DialogHeader,
  DialogBody,
  Button,
} from "@material-tailwind/react";

import { IoEyeSharp } from "react-icons/io5";
import { HiPencilAlt } from "react-icons/hi";
import { FaTrash, FaFileDownload } from "react-icons/fa";
import { MdPictureAsPdf } from "react-icons/md";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import DYNAMICModale from "../Modales/DYNAMIC_modale";
import {
  deleteOneCompanyFeesApi,
  updateCompanyFeesPayStatusApi,
  updateCompanyFeesDocStatusApi,
} from "api/companyFees";

import API_URL from "config";
import { pdfOneCompanyFeeGeneratorApi } from "api/pdf";

function DYNAMIC({
  tableData,
  refreshTableData,
  accessList,
  showToast,
  selectedFilters,
}) {
  const [showCompanyFeesModaleDynamic, setShowCompanyFeesModaleDynamic] = useState(false);
  const [filtredTableData, setFiltredTableData] = useState([]);

  const [selectedData, setSelectedData] = useState({});
  const [selectedTypeOfData, setSelectedTypeOfData] = useState("");

  useEffect(() => {
    getAllTableData();
  }, [tableData]);

  const getSubCategoryName = (el) => {
    try {
      const subCategoryName = el?.feesCategory?.subCategories?.find(
        (sub) => sub._id === el.feesSubCategory
      )?.name;
      return subCategoryName || el?.details || "";
    } catch (err) {
      return el?.details || "";
    }
  };

  const handleUpdatedPayStatus = async (status, id) => {
    try {
      const selectedStatus =
        status == "N" || status == "notPayed" ? "payed" : "notPayed";

      try {
        withReactContent(Swal)
          .fire({
            icon: "warning",
            title: "Changer le statut ?",
            confirmButtonText: "Confirmer",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              try {
                Swal.fire("Modifiée", "", "success");

                await updateCompanyFeesPayStatusApi(selectedStatus, id);
                refreshTableData("success", "Modifiée");
              } catch (err) {
                console.log(err);
              }
            }
          });
      } catch (err) {
        console.log(err);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleUpdatedDocStatus = async (status, id) => {
    try {
      let selectedStatus;
      if (status === "N") {
        selectedStatus = "V";
      } else if (status === "V") {
        selectedStatus = "A";
      } else {
        selectedStatus = "N";
      }

      try {
        withReactContent(Swal)
          .fire({
            icon: "warning",
            title: "Changer le statut du document ?",
            confirmButtonText: "Confirmer",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              try {
                await updateCompanyFeesDocStatusApi(selectedStatus, id);
                showToast("success", "Modifiée");
              } catch (err) {
                console.log(err);
              }
            }
          });
      } catch (err) {
        console.log(err);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getAllTableData = () => {
    try {
        setFiltredTableData(tableData);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDownloadBon = (bonFile) => {
    try {
      window.open(`${API_URL}/${bonFile}`, "_blank");
    } catch (err) {
      console.log(err);
    }
  };

  const handleDownloadPdf = async (data) => {
    try {
      const response = await pdfOneCompanyFeeGeneratorApi(data._id);
      window.open(`${response}`, "_blank");
    } catch (err) {
      console.log(err);
    }
  };

  const handleCompanyFeeEditeModale = (data, type) => {
    try {
      setShowCompanyFeesModaleDynamic(!showCompanyFeesModaleDynamic);
      setSelectedData(data);
      setSelectedTypeOfData(type);
    } catch (err) {
      console.log(err);
    }
  };

  const handleShowToast = (type, message) => {
    showToast(type, message);
  };

  const handleDeleteFee = (el) => {
    try {
      withReactContent(Swal)
        .fire({
          icon: "warning",
          title: "Supprimer ?",
          confirmButtonText: "Supprimer",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              Swal.fire("Supprimée", "", "success");

              await deleteOneCompanyFeesApi(el._id);
              refreshTableData("success", "Supprimée");
            } catch (err) {
              console.log(err);
            }
          }
        });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="mt-8 overflow-x-scroll">
      <Dialog
        size="xl"
        open={showCompanyFeesModaleDynamic}
        handler={handleCompanyFeeEditeModale}
      >
        <DialogHeader>
          <p className="w-full text-center">
            {selectedData?.feesCategory?.category}
          </p>
        </DialogHeader>
        <DialogBody>
          <DYNAMICModale
            closePopup={handleCompanyFeeEditeModale}
            actionType={selectedTypeOfData}
            selectedData={selectedData}
            selectedCategory={selectedData?.feesCategory}
            showToast={handleShowToast}
          />
        </DialogBody>
      </Dialog>

      <div
        className="mt-8 overflow-x-scroll"
        style={{ height: "50vh", overflowY: "scroll" }}
      >
        <table className="w-full">
          <thead>
            <tr>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">Date</p>
              </th>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">Type</p>
              </th>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">Détails</p>
              </th>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">
                  Responsable
                </p>
              </th>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">
                  Etat (Justifié)
                </p>
              </th>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">
                  Etat (Approuvée)
                </p>
              </th>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">Montant</p>
              </th>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">Bon / PDF</p>
              </th>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">
                  Validation
                </p>
              </th>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">
                  Validation (D.G)
                </p>
              </th>
              {accessList.Document && (
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">
                    Document
                  </p>
                </th>
              )}
              {accessList.Paiement && (
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">
                    Paiement
                  </p>
                </th>
              )}
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">Action</p>
              </th>
            </tr>
          </thead>

          <tbody>
            {filtredTableData.map((el) => (
              <tr key={el._id}>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    {el?.date?.split("T")[0]?.split('-').reverse().join('/')}
                  </p>
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    {el?.feesCategory?.category}
                  </p>
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    {getSubCategoryName(el)}
                  </p>
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    {el?.responsable?.Name}
                  </p>
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    {el.isJustify ? "Justifié" : "Non Justifié"}
                  </p>
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    {el.isAproved ? "Approuvée" : "Non Approuvée"}
                  </p>
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    {parseFloat(el.montant).toFixed(2)}
                  </p>
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    <div className="justify-left items-left flex">
                      <FaFileDownload
                        size={30}
                        className="cursor-pointer dark:text-white"
                        onClick={() => handleDownloadBon(el.bonFile)}
                      />
                      <MdPictureAsPdf
                        size={30}
                        className="ml-4 cursor-pointer dark:text-white"
                        onClick={() => handleDownloadPdf(el)}
                      />
                    </div>
                  </p>
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    <Button
                      variant="text"
                      color="gray"
                      className="dark:bg-white"
                    >
                      <span>
                        {el.dynamicValidationStatus === "N"
                          ? "En cours"
                          : el.dynamicValidationStatus === "V"
                          ? "Validée"
                          : "Annulée"}
                      </span>
                    </Button>
                  </p>
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    <Button
                      variant="text"
                      color="gray"
                      className="dark:bg-white"
                    >
                      <span>
                        {el.dgValidationStatus === "N"
                          ? "En cours"
                          : el.dgValidationStatus === "V"
                          ? "Validée"
                          : "Annulée"}
                      </span>
                    </Button>
                  </p>
                </td>

                {accessList.Document && (
                  <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {el.docStatus === "N" ? (
                        <Button
                          color="amber"
                          className="text-white"
                          onClick={() => handleUpdatedDocStatus("N", el._id)}
                        >
                          En cours
                        </Button>
                      ) : el.docStatus === "V" ? (
                        <Button
                          color="#236571"
                          className="text-white"
                          onClick={() => handleUpdatedDocStatus("V", el._id)}
                        >
                          Validé
                        </Button>
                      ) : el.docStatus === "A" ? (
                        <Button
                          color="#cf503f"
                          className="text-white"
                          onClick={() => handleUpdatedDocStatus("A", el._id)}
                        >
                          Annulé
                        </Button>
                      ) : (
                        <Button
                          color="amber"
                          className="text-white"
                          onClick={() => handleUpdatedDocStatus("N", el._id)}
                        >
                          En cours
                        </Button>
                      )}
                    </p>
                  </td>
                )}

                {accessList.Paiement && (
                  <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                    {!el.payeStatus ||
                    el.payeStatus === "" ||
                    el.payeStatus === "N" ? (
                      <Button
                        color="amber"
                        className="text-white"
                        disabled={el.docStatus !== "V"}
                        onClick={() => handleUpdatedPayStatus("N", el._id)}
                      >
                        En course
                      </Button>
                    ) : el.payeStatus === "payed" ? (
                      <Button
                        color="#236571"
                        className="text-white"
                        disabled={el.docStatus !== "V"}
                        onClick={() => handleUpdatedPayStatus("payed", el._id)}
                      >
                        Payée
                      </Button>
                    ) : el.payeStatus === "notPayed" ? (
                      <Button
                        color="#cf503f"
                        className="text-white"
                        disabled={el.docStatus !== "V"}
                        onClick={() => handleUpdatedPayStatus("notPayed", el._id)}
                      >
                        Non payée
                      </Button>
                    ) : (
                      <></>
                    )}
                  </td>
                )}

                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  <div className="flex items-center gap-3">
                    {accessList.Read && (
                      <IoEyeSharp
                        size={20}
                        className="cursor-pointer text-blue-500"
                        onClick={() =>
                          handleCompanyFeeEditeModale(el, "show")
                        }
                      />
                    )}
                    {accessList.Update && (
                      <HiPencilAlt
                        size={20}
                        className="cursor-pointer text-green-500"
                        onClick={() =>
                          handleCompanyFeeEditeModale(el, "update")
                        }
                      />
                    )}
                    {accessList.Delete && (
                      <FaTrash
                        size={20}
                        className="cursor-pointer text-red-500"
                        onClick={() => handleDeleteFee(el)}
                      />
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DYNAMIC;
